import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectKeysPage } from '@/features/ai/llm/key-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Projet → « Clés de la passerelle » : la clé n’est affichée qu’à sa création. */
export const Route = createFileRoute('/$tenant/projects/$projectId/llm-keys')({
  component: ProjectKeysRoute,
});

function ProjectKeysRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="llmKeys"
      crumbs={[{ label: t('nav.items.llmKeys') }]}
    >
      <ProjectKeysPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
